export default __webpack_public_path__ + "svg/calendar/2027/6/noviembre.svg?279d121b";